import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutNavListComponent } from './layout-nav-list/layout-nav-list.component';
import { StpMaterialModule } from '../material/material.module';
import { TitleService } from './services/title.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StpMaterialModule
  ],
  exports: [
    LayoutNavListComponent
  ],
  declarations: [
    LayoutNavListComponent
  ],
  providers: [
    TitleService
  ]
})
export class StpLayoutsModule { }
